module.exports = __webpack_public_path__ + "images/oth-trigger-banner-bg.jpg";